import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById('pain-section');
    const offerBtn = document.getElementById('cta-comprar-1clic');
    if (!trigger || !offerBtn) return;
    const handleScroll = () => {
      const triggerRect = trigger.getBoundingClientRect();
      const offerRect = offerBtn.getBoundingClientRect();
      const pastTrigger = triggerRect.top < window.innerHeight * 0.8;
      const reachedOffer = offerRect.top < window.innerHeight && offerRect.bottom > 0;
      setVisible(pastTrigger && !reachedOffer);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const scrollToOffer = () => {
    const target = document.getElementById('cta-comprar-1clic');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className={`fixed bottom-6 left-1/2 z-50 transition-all duration-500 ease-out ${visible ? 'translate-x-[-50%] translate-y-0 opacity-100' : 'translate-x-[-50%] translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-139">
      <button onClick={scrollToOffer} className="flex items-center gap-2 bg-[#22C55E] text-white font-black text-[14px] md:text-[15px] py-3 px-6 rounded-full shadow-[0_4px_20px_rgba(34,197,94,0.35)] cursor-pointer transition-all duration-200 hover:shadow-[0_6px_28px_rgba(34,197,94,0.45)] hover:bg-[#1EAD52] font-[Inter,_sans-serif]" data-id="element-140">
        <span data-id="element-141">Sí, quiero mi transformación</span>
        <ArrowRight className="w-4 h-4 text-white/80" data-id="element-142" />
      </button>
    </div>;
}